export default function FidelityDiscountIcon(props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 14 14"
			width="1em"
			height="1em"
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M5.956 3.391H3.449a1.4 1.4 0 0 1-.277-.712c-.023-.256.04-.434.139-.543c.091-.101.316-.257.861-.257c.497 0 1.008.34 1.442.94c.137.19.25.386.342.572m-4.279-.58q.028.295.115.58h-.594a1 1 0 0 0-1 1v.882a1 1 0 0 0 1 1h11.604a1 1 0 0 0 1-1v-.882a1 1 0 0 0-1-1h-.594q.088-.285.115-.58c.048-.552-.072-1.182-.52-1.68C11.348.628 10.663.38 9.828.38c-1.2 0-2.103.792-2.659 1.564a5 5 0 0 0-.169.25a5 5 0 0 0-.17-.25C6.276 1.17 5.372.379 4.173.379c-.836 0-1.52.248-1.975.753c-.449.497-.568 1.127-.52 1.68Zm6.367.58h2.507a1.4 1.4 0 0 0 .277-.712c.023-.256-.04-.434-.139-.543c-.091-.101-.316-.257-.861-.257c-.497 0-1.008.34-1.442.94c-.137.19-.25.386-.342.572M1.198 7.523h5.177v6.332H2.154a1 1 0 0 1-1-1V7.523zm10.648 6.332H7.625V7.523h5.221v5.332a1 1 0 0 1-1 1"
				clipRule="evenodd"
			></path>
		</svg>
	);
}
